import * as React from 'react';

import PropTypes from 'prop-types';

// @ts-ignore
import BirthdateSelector from 'chat/components/BirthdateSelector';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
// @ts-ignore
import UserActions from 'user/UserActions';
import errorLogger from 'utils/errorLogger';

type State = {
  birthdate?: Date | null;
};

type Props = {
  onRequestHide: () => void;
} & State;

class BirthdayInterruptModal extends React.Component<Props, State> {
  state: State = {
    birthdate: this.props.birthdate || null,
  };

  onChange = (birthdate: Date) => {
    this.setState({ birthdate });
  };
  onSave = () => {
    const { birthdate } = this.state;
    if (!birthdate) {
      console.error('skipping attempt to save falsy birthdate');
      return;
    }
    UserActions.setBirthdate(birthdate)
      .then(() => {
        if (this.props.onRequestHide) {
          this.props.onRequestHide();
        }
      })
      .catch(errorLogger('BirthdayInterruptModal - can’t set birthday on user'));
  };
  render() {
    return (
      <Dialog
        eventScreenName="BirthdayInterruptModal"
        className="BirthdayInterruptModal"
        title="When is your birthday?"
        size="small"
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <BirthdateSelector onChange={this.onChange} />
          <Button
            disabled={this.state.birthdate === null}
            className="BirthdayInterruptModal-saveButton"
            onClick={this.onSave}>
            Save
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}
export default BirthdayInterruptModal;
